module.exports = __webpack_public_path__ + "static/media/verdeLips.1aa0a411.jpg";